// extracted by mini-css-extract-plugin
export default {"container":"Table_container__5LqRZ","activeRow":"Table_activeRow__WlQsk","nobackground":"Table_nobackground__+fiHx","noresults":"Table_noresults__Wn3+j"};